import React from "react";

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {LeftArrow} from "../../../../core/icons/arrows/left-arrow";
import {RightArrow} from "../../../../core/icons/arrows/right-arrow";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsBackwardArrowDesktopProps extends BaseProps {
  className: String;
  isRtl: Boolean;
  onClickPrev: Function;
}

export const BoxScoresWidgetTableStatsBackwardArrowDesktop = (({onClickPrev, isRtl, className}: BoxScoresWidgetTableStatsBackwardArrowDesktopProps) => {
  const backwardContainer = {
    className: classnames(styles.table_arrow_container, styles.table_arrow_container_backward),
    onClick: () => onClickPrev?.()
  }

  return (
    <div {...backwardContainer}>
      {
        isRtl ? <RightArrow className={className}/> : <LeftArrow className={className}/>
      }
    </div>
  )
});